// @flow

import type { AppType } from "shared/types/AppType"

export default ({
  asyncComponentResolve: () => import("apps/vouchers/VouchersEntry"),
  iconType: "gift",
  name: "vouchers",
  requirePermission: "vouchers:admin-view",
  subApps: [
    {
      name: "buckets"
    },
    {
      name: "search",
      requirePermission: "vouchers:voucher-search"
    }
  ]
}: AppType)
